import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

export function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  w = 280,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  w?: number | string;
}) {
  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      placeholder={placeholder}
      leftSection={<IconSearch size={16} />}
      w={w}
    />
  );
}
